import React from 'react';
import {
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import CreateProjectPage from './CreateProjectPage';
import ProjectsList from './ProjectsList';
import ProjectViewerPage from './ProjectViewerPage';
import UpdateProjectPage from './UpdateProjectPage';
// import UploadModelWizard from './UploadModelWizard';

export default function () {
  return (
    <Routes>
      <Route path='/new' element={<CreateProjectPage />}/>
      <Route path='/' element={<ProjectsList />} />
      <Route path='/:id' element={<ProjectViewerPage />} />
      <Route path='/:id/settings' element={<UpdateProjectPage />} />
      <Route path='/:id/settings/:subsection' element={<UpdateProjectPage />} />
      <Route path='/:id/settings/:subsection/*' element={<Navigate to="./" replace/>} />
      <Route path='/*' element={<Navigate to="./" replace/>} />
    </Routes>
  );
};